import { z } from 'zod';
/**
 * A real person who plays at the table. This is a GM-global roster (not tied to a single
 * adventure): the same person can appear in many instances, linked to different PGs.
 * `phone` is the cellular used to build WhatsApp/SMS deep-links when sharing a booking link.
 */
export const personSchema = z.object({
    schemaVersion: z.literal(1).default(1),
    id: z.string(),
    name: z.string(),
    /** Cellular number, free-form (kept as typed; sanitized only when building deep-links). */
    phone: z.string().default(''),
    email: z.string().default(''),
    notes: z.string().default(''),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** Payload to create/update a person from the People page. */
export const personInputSchema = z.object({
    name: z.string().min(1),
    phone: z.string().optional(),
    email: z.string().optional(),
    notes: z.string().optional(),
});
//# sourceMappingURL=people.js.map